import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { TamperEvent } from '@app/models/tamper-event.interface';
import { AuthService } from '@app/services/auth.service';
import { TamperEventHelperService } from '@app/services/helpers/tamper-event-helper.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faCirclePlus,
  faArrowLeft 
 } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-tamper-events',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        FontAwesomeModule,
        RouterModule,
    ],
    templateUrl: './listing.page.html',
    styleUrl: './listing.page.scss'
})
export class TamperEventsPage {
  public title = 'Tamper Events';
  tamperEventes$: Observable<TamperEvent[]>;

  faCirclePlus = faCirclePlus;
  faArrowLeft = faArrowLeft;

  constructor(
    private tamperEventHelper: TamperEventHelperService,
    public auth: AuthService,
  ) {
    this.tamperEventes$ = this.tamperEventHelper.getAll();
  }
}
